import { SubscriptionSessionPackUsageHistoryDTO } from "@gymflow/types";
import { Coins03Icon } from "apps/portal/src/components/atoms/icons/Coins03Icon";
import { useClubSettings } from "apps/portal/src/providers";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { UsageItemStatus } from "./components/UsageItemStatus";

type UsageItemProps = {
  usageInfo: SubscriptionSessionPackUsageHistoryDTO;
};

export const UsageItem = ({ usageInfo }: UsageItemProps) => {
  const { t } = useTranslation();
  const {
    club: { timezone },
  } = useClubSettings();

  const startDate = DateTime.fromISO(usageInfo.startDate).setZone(timezone);
  const usedAt = DateTime.fromISO(usageInfo.usedAt).setZone(timezone);

  return (
    <div className="flex flex-row gap-2.5">
      <div className="flex flex-col items-center gap-1 px-1 pt-1">
        <div className="size-3 rounded-full bg-gray-300 dark:bg-gray-700" />
        <div className="w-px flex-1 rounded-full bg-gray-300 dark:bg-gray-700" />
      </div>
      <div className="flex flex-1 flex-col gap-2 last:mb-6">
        <div className="flex flex-row items-center gap-1.5 text-sm font-semibold text-gray-500 dark:text-gray-400">
          {usedAt.toLocaleString(DateTime.DATE_MED)}
          <div className="size-1.5 rounded-full bg-gray-300 dark:bg-gray-700" />
          {usedAt.toLocaleString(DateTime.TIME_SIMPLE)}
        </div>
        <div className="flex flex-row items-center justify-between rounded-xl border border-gray-200 p-3 dark:border-gray-600">
          <div className="flex flex-col gap-1">
            <div className="dark:text-gray-25 text-sm font-semibold text-gray-950">
              {usageInfo.name}
            </div>
            <div className="flex flex-row items-center gap-1.5 text-xs font-semibold text-gray-500 dark:text-gray-400">
              {t("components.usageItem.on", {
                startDate: startDate.toLocaleString(DateTime.DATE_MED),
              })}
              <div className="size-1.5 rounded-full bg-gray-300 dark:bg-gray-700" />
              {startDate.toLocaleString(DateTime.TIME_SIMPLE)}
            </div>
          </div>
          <div className="flex flex-col items-end gap-1">
            <div className="flex items-center gap-1">
              <div className="dark:text-gray-25 text-lg font-bold text-gray-950">
                -{usageInfo.sessionsUsed}
              </div>
              <Coins03Icon
                className="size-5"
                pathClassName="stroke-secondary-500"
              />
            </div>
            <UsageItemStatus status={usageInfo.status} />
          </div>
        </div>
      </div>
    </div>
  );
};
